import './styles/pricing-page.css'
import { initReveal } from './reveal'
import { initNav } from './nav'
import { initAnalytics } from './analytics'

document.documentElement.dataset['env'] = import.meta.env.VITE_ENV_NAME

initAnalytics()
initNav()
initReveal()
